import { createReducer } from '../utils/reducers';
import {
    CARD_PAYMENT_REQUEST,
    CARD_PAYMENT_FAILURE,
    CARD_PAYMENT_SUCCESS,
    CARD_PAYMENT_SUBMITTED,
    DISCOUNT_REQUEST,
    DISCOUNT_SUCCESS,
    DISCOUNT_FAILURE,
    SUBSCRIBE_REQUEST,
    SUBSCRIBE_SUCCESS,
    SUBSCRIBE_FAILURE,
    SUBSCRIBE_SUBMITTED,
    FREEMIUM_PAYMENT_SUCCESS,
    PAYMENT_METHODS_REQUEST,
    PAYMENT_METHODS_SUCCESS,
    PAYMENT_METHODS_FAILURE,
    PAYPAL_PARAMS_SUCCESS,
    RESET_VOUCHER_VALUE,
} from '../actions';

const INITIAL_STATE = {
    isProcessing: false,
    isSubmitted: false,
    isFreemium: false,
    isPaymentLoading: false,
};

export const payments = createReducer(INITIAL_STATE, {
    [CARD_PAYMENT_REQUEST]: state => {
        return {
            ...state,
            isProcessing: true,
        };
    },
    [CARD_PAYMENT_SUBMITTED]: state => {
        return {
            ...state,
            isSubmitted: true,
        };
    },
    [CARD_PAYMENT_SUCCESS]: () => {
        return INITIAL_STATE;
    },
    [CARD_PAYMENT_FAILURE]: () => {
        return INITIAL_STATE;
    },
    [SUBSCRIBE_REQUEST]: state => {
        return {
            ...state,
            isProcessing: true,
        };
    },
    [SUBSCRIBE_SUBMITTED]: state => {
        return {
            ...state,
            isSubmitted: true,
        };
    },
    [SUBSCRIBE_SUCCESS]: () => {
        return INITIAL_STATE;
    },
    [SUBSCRIBE_FAILURE]: () => {
        return INITIAL_STATE;
    },
    [FREEMIUM_PAYMENT_SUCCESS]: state => {
        return {
            ...state,
            isFreemium: true,
        };
    },
    [PAYMENT_METHODS_REQUEST]: (state, action) => {
        return {
            ...state,
            isPaymentLoading: true,
        };
    },
    [PAYMENT_METHODS_SUCCESS]: (state, action) => {
        return {
            ...state,
            paymentMethods: action.data,
            isPaymentLoading: false,
        };
    },
    [PAYMENT_METHODS_FAILURE]: (state, action) => {
        return {
            ...state,
            isPaymentLoading: false,
        };
    },
});

const INITIAL_DISCOUNT_STATE = {
    isFetching: false,
    message: '',
};

export const discount = createReducer(INITIAL_DISCOUNT_STATE, {
    [DISCOUNT_REQUEST]: () => {
        return {
            ...INITIAL_DISCOUNT_STATE,
            isFetching: true,
        };
    },
    [DISCOUNT_SUCCESS]: (state, action) => {
        return {
            ...state,
            ...action.data,
            isFetching: false,
            message: '',
        };
    },
    [DISCOUNT_FAILURE]: (state, action) => {
        return {
            ...INITIAL_DISCOUNT_STATE,
            message: action.data.message
                ? action.data.message
                : action.data.errors.voucher_code,
        };
    },
    [RESET_VOUCHER_VALUE]: state => {
        return {
            ...INITIAL_DISCOUNT_STATE,
        };
    },
});



// WEBPACK FOOTER //
// ./src/reducers/payments.js